import { getAssetUrl } from "@/constant/assets";
import { getTargetWidthImage } from "@/lib/utils";
import { ImageProps } from "next/image";
import Image from "next/image";
import React from "react";

interface ImageComponentProps extends ImageProps {
  optimizedWidth?: number;
}

// 支持外部的ref引入
const ImageComponent = React.forwardRef<HTMLImageElement, ImageComponentProps>((props, ref) => {
  const { optimizedWidth, ...restProps } = props;
  const imageProps = { alt: props.alt ?? '', ...restProps };

  const rawSrc = props.src;
  if (typeof rawSrc === 'string') {
    const normalizedSrc = rawSrc.trim();
    // Avoid passing empty string to <Image src>, which triggers noisy runtime errors.
    if (!normalizedSrc) {
      return null;
    }

    let assetUrl = getAssetUrl(normalizedSrc);
    if (optimizedWidth && optimizedWidth > 0) {
      assetUrl = getTargetWidthImage(assetUrl, optimizedWidth);
    }

    return (
      <Image
        {...imageProps}
        alt={imageProps.alt}
        ref={ref}
        src={assetUrl}
        unoptimized
      />
    );
  }

  // StaticImport path
  return (
    <Image
      {...imageProps}
      alt={imageProps.alt}
      ref={ref}
      src={rawSrc}
      unoptimized
    />
  );
});

ImageComponent.displayName = 'ImageComponent';

export default ImageComponent;
